export const REQUEST_DELETE_REASON_LOADING = "REQUEST_DELETE_REASON_LOADING";
export const REQUEST_DELETE_REASON_SUCCESS = "REQUEST_DELETE_REASON_SUCCESS";
export const REQUEST_DELETE_REASON_FAIL = "REQUEST_DELETE_REASON_FAIL";

export const POPUP_DELETE_REASON = {
  REQUEST_DELETE_REASON_LOADING,
  REQUEST_DELETE_REASON_SUCCESS,
  REQUEST_DELETE_REASON_FAIL,
};
